
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"url","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_464","data-name":"Path 464","d":"M11,0A4.691,4.691,0,0,0,7.5,1.5L6.3,2.6A.967.967,0,0,0,6.3,4,.967.967,0,0,0,7.7,4L8.9,2.8a3.085,3.085,0,0,1,4.2,0A3.1,3.1,0,0,1,14,5a2.723,2.723,0,0,1-.9,2.1L12,8.3a.967.967,0,0,0,0,1.4.967.967,0,0,0,1.4,0l1.2-1.2A5,5,0,0,0,16,5a4.691,4.691,0,0,0-1.5-3.5A4.691,4.691,0,0,0,11,0Z","fill":"#98a9b3"}}),_c('path',{attrs:{"id":"Path_465","data-name":"Path 465","d":"M8.3,12,7.1,13.2a3.085,3.085,0,0,1-4.2,0A3.1,3.1,0,0,1,2,11a2.723,2.723,0,0,1,.9-2.1L4,7.7A.967.967,0,0,0,4,6.3a.967.967,0,0,0-1.4,0L1.5,7.5A4.691,4.691,0,0,0,0,11a4.691,4.691,0,0,0,1.5,3.5A4.691,4.691,0,0,0,5,16a4.691,4.691,0,0,0,3.5-1.5l1.2-1.2A.958.958,0,1,0,8.3,12Z","fill":"#98a9b3"}}),_c('path',{attrs:{"id":"Path_466","data-name":"Path 466","d":"M9.4,5.2,5.2,9.4a.967.967,0,0,0,0,1.4,1.08,1.08,0,0,0,.7.3,1.08,1.08,0,0,0,.7-.3l4.2-4.2A.99.99,0,1,0,9.4,5.2Z","fill":"#24439c"}})])
          )
        }
      }
    